import styled from "@emotion/styled";

import { BREAKPOINTS, media } from "../constants";
import { Div } from "./layout";

export const SliderSlide = styled(Div)`
  label: slider-slide;
  background: #fff;
  box-shadow: 0 0 5px #ccc;
  text-align: center;
  min-height: 320px;
  position: relative;
  gap: 10px;
  border-radius: 20px;
  padding: 20px;

  ${media.min(BREAKPOINTS.desktopMin)} {
    width: 420px;
  }

  ${media.max(BREAKPOINTS.desktopMin - 1)} {
    width: 100%;
  }
`;

export const SliderDotsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  max-width: 100%;
  padding: 0 8px;
  box-sizing: border-box;
`;

export const SliderArrowButton = styled.button`
  position: absolute;
  top: 50%;
  ${({ left }) => (left ? "left: 15px;" : "right: 15px;")}
  transform: translateY(-50%) ${({ left }) => (left ? "rotate(180deg)" : "")};
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }
`;

export const SliderDots = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const SliderDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ active, onPrimary }) => {
    if (active) return onPrimary ? '#fff' : '#000';
    return onPrimary ? 'rgba(255, 255, 255, 0.45)' : '#ccc';
  }};
  display: inline-block;
  cursor: pointer;
`;


